import memoize from '@stripcash/ui-kit/utils/memoize';
import { Selector } from 'react-redux';

import { GetStateFromSelectors } from '../reselectTypes';

import { SelectorArray, Combiner } from './types';

const createCustomSelectorHook =
  (type: string) =>
  <Result, Selectors extends SelectorArray>(
    ...selectorsList: [...Selectors, Combiner<Selectors, Result>]
  ): Selector<GetStateFromSelectors<Selectors>, Result> => {
    const combiner = selectorsList[selectorsList.length - 1];
    const selectors = selectorsList.slice(0, -1);
    const memoizedCombiner = memoize(combiner, { max: 1 });

    const selector = (state) =>
      selectors.length === 0
        ? // @ts-ignore
          memoizedCombiner(state) // @ts-ignore
        : memoizedCombiner(...selectors.map((selector) => selector(state)));

    selector.type = type;

    return selector as Selector<GetStateFromSelectors<Selectors>, Result>;
  };

export default createCustomSelectorHook;
